import * as React from 'react'
import moment from 'moment'
import { inject } from 'mobx-react'
import { CurrentCompanyStore } from '../../stores/CurrentCompanyStore'
import { IPayment, PaymentStatus } from '@getgreenline/homi-shared'
import './CustomerPayments.scss'
import { CustomerReceiptModal } from '../../containers/CustomerReceiptModal'
import { LoyaltyDiscountUtils, LoyaltyModels } from '@getgreenline/loyalties'

interface IProps {
  currentCompanyStore?: CurrentCompanyStore
  payments: IPayment[]
}

interface IState {
  selectedPayment?: IPayment | undefined
  loyaltyData?: LoyaltyModels.ILoyaltyData
}

@inject('currentCompanyStore')
export class CustomerPayments extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      selectedPayment: undefined,
    }
  }

  getStatusClassName = (status: PaymentStatus) => {
    switch (status) {
      case 'pending':
      case 'refunded':
        return 'text-muted'
      case 'in progress':
        return 'text-info'
      case 'completed':
        return 'text-success'
      default:
        return 'text-danger'
    }
  }

  handleClick = async (payment: IPayment) => {
    const { currentCompanyStore } = this.props
    let loyaltyData = this.state.loyaltyData

    if (
      currentCompanyStore &&
      currentCompanyStore.company?.permissions.canAccessLoyalty &&
      this.state.loyaltyData === undefined
    ) {
      const { canDisplayLoyaltyInfoOnReceipt, canUseCustomReceipt, customReceiptSettings } =
        currentCompanyStore
      currentCompanyStore.getShouldDisplayInternalLoyaltyData(payment.locationId)

      loyaltyData = currentCompanyStore.shouldDisplayInternalLoyaltyData
        ? await LoyaltyDiscountUtils.getLoyaltyData(
            currentCompanyStore.company?.permissions,
            payment,
            {
              canDisplayLoyaltyInfoOnReceipt,
              canUseCustomReceipt,
            },
            customReceiptSettings.get(payment.locationId)?.showLoyalty,
          )
        : undefined
    }

    this.setState({
      selectedPayment: payment,
      loyaltyData,
    })
  }

  render() {
    const { payments } = this.props

    return (
      <>
        <br />
        <div className='payments-container'>
          <table className='table table-striped'>
            <tbody>
              <tr>
                <td>Number of visits</td>
                <td className='text-right'>
                  <b>{payments.length}</b>
                </td>
              </tr>
              {payments.map((payment) => {
                return (
                  <tr key={payment.id}>
                    <td>
                      <a onClick={() => this.handleClick(payment)}>
                        {moment(payment.createDate).format('YYYY-MM-DD hh:mm a')}
                      </a>
                    </td>
                    <td className={'text-right ' + this.getStatusClassName(payment.status)}>
                      {payment.status}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>

        {this.state.selectedPayment ? (
          <CustomerReceiptModal
            payment={this.state.selectedPayment}
            loyaltyData={this.state.loyaltyData}
            onHide={() => this.setState({ selectedPayment: undefined, loyaltyData: undefined })}
          />
        ) : undefined}
      </>
    )
  }
}
